import React from 'react';
import './Certification.css'; // Make sure this file exists with the CSS styles below

const certifications = [
  {
    title: 'QuickBooks Desktop Certification',
    image: '../assets/images/desk1.png',
    date: 'June 5, 2025',
  },
  {
    title: 'Intuit Bookkeeping Certification',
    image: '../assets/images/des2.jfif',
    date: 'June 5, 2025',
  },
  {
    title: 'QuickBooks Online Certification Level 1',
    image: '../assets/images/des3.jfif',
    date: 'June 6, 2025',
  },
];

const Certifications = () => {
  return (
    <div className="certifications-container">
      <h2 className="certifications-heading">Certifications</h2>
      <div className="certifications-grid">
        {certifications.map((cert, index) => (
          <div key={index} className="cert-card">
            <h3 className="cert-title">{cert.title}</h3>

            {cert.image ? (
              <div className="cert-image-wrapper">
                <img src={cert.image} alt={cert.title} className="cert-image" />
              </div>
            ) : (
              <div className="cert-badge-wrapper">
                <div className="cert-badge">
                  <div className="cert-level">{cert.level}</div>
                  <div className="cert-badge-text" style={{ backgroundColor: cert.badgeColor }}>
                    {cert.badgeText}
                  </div>
                  <div className="cert-proadvisor">ProAdvisor</div>
                </div>
              </div>
            )}

            {/* <p className="cert-date">
              You’ve completed {cert.title} on {cert.date}.
            </p> */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Certifications;
